/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CategoryWithFamilyResource } from './';
import {
    CategoryWithFamilyResourceFromJSON,
    CategoryWithFamilyResourceFromJSONTyped,
    CategoryWithFamilyResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateSignupFamiliesAndCategoriesRequest
 */
export interface UpdateSignupFamiliesAndCategoriesRequest {
    /**
     * 
     * @type {CategoryWithFamilyResource}
     * @memberof UpdateSignupFamiliesAndCategoriesRequest
     */
    preferredCategory: CategoryWithFamilyResource;
    /**
     * 
     * @type {Array<CategoryWithFamilyResource>}
     * @memberof UpdateSignupFamiliesAndCategoriesRequest
     */
    categories: Array<CategoryWithFamilyResource>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSignupFamiliesAndCategoriesRequest
     */
    selectedByPredictions: boolean;
}

/**
 * Check if a given object implements the UpdateSignupFamiliesAndCategoriesRequest interface.
 */
export function instanceOfUpdateSignupFamiliesAndCategoriesRequest(value: object): value is UpdateSignupFamiliesAndCategoriesRequest {
    if (!('preferredCategory' in value) || value['preferredCategory'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    if (!('selectedByPredictions' in value) || value['selectedByPredictions'] === undefined) return false;
    return true;
}

export function UpdateSignupFamiliesAndCategoriesRequestFromJSON(json: any): UpdateSignupFamiliesAndCategoriesRequest {
    return UpdateSignupFamiliesAndCategoriesRequestFromJSONTyped(json, false);
}

export function UpdateSignupFamiliesAndCategoriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSignupFamiliesAndCategoriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'preferredCategory': CategoryWithFamilyResourceFromJSON(json['preferredCategory']),
        'categories': ((json['categories'] as Array<any>).map(CategoryWithFamilyResourceFromJSON)),
        'selectedByPredictions': json['selectedByPredictions'],
    };
}

export function UpdateSignupFamiliesAndCategoriesRequestToJSON(value?: UpdateSignupFamiliesAndCategoriesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'preferredCategory': CategoryWithFamilyResourceToJSON(value['preferredCategory']),
        'categories': ((value['categories'] as Array<any>).map((v) => CategoryWithFamilyResourceToJSON(v))),
        'selectedByPredictions': value['selectedByPredictions'],
    };
}

